import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getDeliveryVehicle = createAsyncThunk(
  "admin/delivery-vehicle",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/delivery-vehicle", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDeliveryVehicleById = createAsyncThunk(
  "admin/delivery-vehicle/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/delivery-vehicle/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortDeliveryVehicle = createAsyncThunk(
  "admin/delivery-vehicle/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/delivery-vehicle/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postDeliveryVehicle = createAsyncThunk(
  "admin/delivery-vehicle/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/delivery-vehicle", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteDeliveryVehicle = createAsyncThunk(
  "admin/delivery-vehicle/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/delivery-vehicle/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateDeliveryVehicle = createAsyncThunk(
  "admin/delivery-vehicle/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/delivery-vehicle/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const deliveryVehicleSlice = createSlice({
  name: "Delivery Vehicle Store",
  initialState: initialState,
  reducers: {
    addDeliveryVehicle(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortDeliveryVehicle(state, action) {
      state.data.docs = action.payload;
    },
    deleteDeliveryVehicle(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editDeliveryVehicle(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getDeliveryVehicle.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getDeliveryVehicle.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getDeliveryVehicle.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDeliveryVehicleById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getDeliveryVehicleById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDeliveryVehicleById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDeliveryVehicle.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortDeliveryVehicle.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDeliveryVehicle.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postDeliveryVehicle.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postDeliveryVehicle.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postDeliveryVehicle.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteDeliveryVehicle.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteDeliveryVehicle.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteDeliveryVehicle.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateDeliveryVehicle.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateDeliveryVehicle.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateDeliveryVehicle.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const deliveryVehicleActions = deliveryVehicleSlice.actions;

export default deliveryVehicleSlice.reducer;
